const configuration = {
  apiUrl: process.env.REACT_APP_API_ENDPOINT || 'https://dev.rentistic.com/api/',
  //vapidPublicKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
  vapidPublicKey:
    'BAioBJhoGbXqsmDXT6VXjm_WrF6s7KzWcMDniwDj1vKLddyCzsQ1WTyVB7ghZnnhzhFo3wiivyzBR0Hh7eK5mE4',
  clientId: process.env.REACT_APP_CLIENT_ID,
  clientSecret: process.env.REACT_APP_CLIENT_SECRET,
  isProduction: process.env.NODE_ENV === 'production',
  maxResolution: '1600x1200',
  maxSize: '10MB',
  currency: { euro: 'EUR' },
  intercomAppId: 'himstccd',
  REACT_APP_GOOGLE_MAPS_API_KEY: 'AIzaSyAFJzW74R6S65SpiUq3joSHhTqE9-AwU-4',
  REACT_APP_RECAPTCHA_SITE_KEY: '6LeKqi8sAAAAANSKEUv3Qk9ByHbDEr-uO71_6fb3',
  raygunApiKey: '0FGDfxilXVL77srCEj8cVw',
};

export default configuration;
